<app-loader [isLoading]="isLoading"></app-loader>

@if(!isMobileView){
  <div class="modal-heading">
    <h2 class="modal-title">Manage User Permissions</h2>
    <div class="close-button" (click)="closeDialog()">
      <mat-icon class="close-icon">close</mat-icon>
    </div>
  </div>
  
<div class="modal-container">
    <div class="d-flex flex-column permission-view-section" style="gap:16px;">
      <app-permission-viewer 
        [views]="showPermissions" 
        [showLabel]="showLabel" 
        [managerPermission]="rolePermissionList"
        (permissionToogleOff)="onTogglePermissionNew($event.rowData)"
       ></app-permission-viewer>

      <!-- <div class="btn-container">
        <button class="dp-secondary-btn btn-div w-100" (click)="saveChanges()">
          Save</button>
      </div> -->
    </div>
  </div>

} @else {
  <div class="modal-heading">
    <h2 class="modal-title">Manage user</h2>
    <div class="close-button" (click)="closeDialog()">
      <mat-icon class="close-icon">close</mat-icon>
    </div>
  </div>
  
<div class="modal-container">
  <form [formGroup]="userForm" class="form-container">
    <div class="d-flex flex-column" style="gap: 20px">
      <div class="user-details-div d-flex justify-content-between">
        <div class="d-flex align-items-center" style="gap: 8px">
          <span class="user-status-text"> User Status</span>
          <span class="active-text" [ngClass]="data.userDetails.status == 'Inactive'? 'warn-status' : ''">{{ data.userDetails.status }}</span>
        </div>
        <div>
          <label class="switch">
            <input
              type="checkbox"
              [checked]="statusActive"
              formControlName="userStatus"
              (change)="onStatusToggle($event)"
            />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      
    </div>
  </form>

  <div class="permission-view-section-mob" style="gap:16px;">
    <app-permission-viewer 
      [views]="showPermissions" 
      [showLabel]="showLabel" 
      [managerPermission]="rolePermissionList"
      (permissionToogleOff)="onTogglePermissionNew($event.rowData)"
     ></app-permission-viewer>
    <!-- <div class="btn-container">
      <button class="dp-secondary-btn btn-div w-100" (click)="saveChanges()">
        Save</button>
    </div> -->
  </div>

  </div>
}
